var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanola({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 230.58 109.62",
    style: {
      enableBackground: "new 0 0 230.58 109.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#849938;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.82,62.46c-1.56-0.54-4.14-0.96-5.94-0.96c-3.78,0-5.1,1.38-5.1,3.3c0,4.32,10.62,4.5,10.62,14.34 c0,8.34-7.44,15.24-18.06,15.24c-3.12,0-6.12-0.3-8.34-0.72l1.92-10.38c1.92,0.72,5.16,1.26,7.5,1.26c3.36,0,4.92-1.2,4.92-3.36 c0-4.32-10.56-4.2-10.56-14.34c0-7.74,5.58-14.64,17.46-14.64c2.7,0,5.16,0.24,7.44,0.6L26.82,62.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,72.96c-1.02-0.42-2.16-0.6-3.36-0.6c-4.44,0-6.3,4.68-6.3,8.58c0,2.34,1.32,3.72,3.84,3.72 c1.32,0,2.76-0.18,4.02-0.6l-1.14,9.48c-1.98,0.6-4.14,0.84-6.18,0.84c-8.22,0-11.88-4.02-11.88-11.04 c0-11.52,7.14-20.4,18.12-20.4c1.86,0,3.6,0.18,5.4,0.54L50.4,72.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.32,93.54c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7h-0.12 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72c0-11.64,6.6-21.6,19.74-21.6c3.9,0,8.22,0.24,12.36,1.02 C80.94,83.22,79.32,93.54,79.32,93.54z M70.38,71.58c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C71.82,71.7,71.22,71.58,70.38,71.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.48,93.54h-10.74l3.48-18.18c0.42-2.22,0.18-2.94-0.6-2.94c-1.86,0-6.18,6-7.38,12.24l-1.68,8.88H86.82 l4.14-21.48v-0.12c-1.38-0.24-3.36-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.38-0.72,15.42-0.54c-0.3,1.5-0.78,3.48-1.8,5.7h0.12 c2.64-3.84,5.94-6.42,10.8-6.42c6.12,0,7.68,4.38,6.66,9.66L114.48,93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.74,94.26c-9.54,0-12.66-4.26-12.66-10.86c0-13.32,9.54-20.4,18.9-20.4c9.42,0,12.54,4.74,12.54,11.1 C152.52,86.28,143.58,94.26,133.74,94.26z M138.3,72.48c-4.14,0-6,5.64-6,9.3c0,1.56,0.6,2.94,2.7,2.94c4.5,0,6.24-5.46,6.24-9.18 C141.24,73.5,140.52,72.48,138.3,72.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.88,93.54h-10.74l6.78-35.58c-1.38-0.24-3.3-0.48-5.04-0.6l1.32-7.14c4.98-0.54,10.32-0.72,16.02-0.54 L164.88,93.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.24,93.54c0,0-1.74,0.12-6.6,0.12c-1.26,0-2.52,0-3.78-0.06c0.48-2.04,0.9-3.66,1.74-5.7h-0.12 c-2.82,4.2-6.36,6.42-10.5,6.42c-4.92,0-7.5-3.18-7.5-9.72c0-11.64,6.6-21.6,19.74-21.6c3.9,0,8.22,0.24,12.36,1.02 C199.85,83.22,198.24,93.54,198.24,93.54z M189.3,71.58c-4.08,0-6.72,6.36-6.72,10.92c0,1.56,0.24,2.34,1.14,2.34 c2.28,0,6.42-6.72,7.38-11.7l0.24-1.26C190.74,71.7,190.14,71.58,189.3,71.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.52,22.79C226.85,15.4,229.42,4.46,230.58,0c-2.89,3.98-9.35,6.39-13.5,7.39 c-3.78,0.92-11.1,1.93-18.09,5.3c-6.95,3.35-9.73,9.03-11.77,13.37c-2.24,4.77-3.49,12.29-3.49,12.29 C191.83,28.98,197.13,28.08,209.52,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.62,30.52c-17.33,7.39-19.9,18.34-21.06,22.8c2.9-3.99,9.35-6.39,13.5-7.4c3.78-0.92,11.1-1.93,18.09-5.3 c6.95-3.34,9.73-9.03,11.77-13.37c2.24-4.77,3.49-12.3,3.49-12.3C219.32,24.34,214.01,25.23,201.62,30.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanola);
export default __webpack_public_path__ + "static/media/Scanola.884357f8788c4bc4866b9e295c32cc0c.svg";
export { ForwardRef as ReactComponent };